// extracted by mini-css-extract-plugin
var _1 = "h8aN3ZrS";
export { _1 as "inputCard" }
